import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { Refresh, Home } from '@mui/icons-material';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary capturó:', error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
          <Paper sx={{ p: 4, maxWidth: 560, textAlign: 'center' }}>
            <Typography variant="h6" color="error" gutterBottom>
              Ocurrió un error al renderizar esta vista
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {String(this.state.error?.message || this.state.error)}
            </Typography>
            <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mb: 3 }}>
              La vista falló, pero el resto de la plataforma sigue disponible.
            </Typography>
            <Button variant="contained" startIcon={<Refresh />}
              onClick={() => this.setState({ error: null })} sx={{ mr: 1 }}>
              Reintentar
            </Button>
            <Button startIcon={<Home />} href="/dashboard">
              Ir al Dashboard
            </Button>
          </Paper>
        </Box>
      );
    }
    return this.props.children;
  }
}
